import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "drivr-auth-ui__login-page" }
const _hoisted_2 = { class: "drivr-auth-ui__welcome" }
const _hoisted_3 = {
  key: 0,
  class: "drivr-auth-ui__introduction"
}
const _hoisted_4 = {
  key: 1,
  class: "drivr-auth-ui__error"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("strong", { class: "drivr-auth-ui__error-title" }, "Error:", -1)
const _hoisted_6 = { class: "drivr-auth-ui__error-message" }
const _hoisted_7 = {
  key: 2,
  class: "drivr-auth-ui__buttons"
}
const _hoisted_8 = ["action"]
const _hoisted_9 = {
  key: 0,
  class: "drivr-auth-ui__divider"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { class: "drivr-auth-ui__divider-content" }, "or", -1)
const _hoisted_11 = [
  _hoisted_10
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ui_button = _resolveComponent("ui-button")!
  const _component_ui_input = _resolveComponent("ui-input")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["drivr-auth-ui__login-page-wrap", { 'drivr-auth-ui__login-page-wrap--show': _ctx.showLogin, 'drivr-auth-ui__login-page-wrap--animate': _ctx.animateLogin }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h2", _hoisted_2, _toDisplayString(_ctx.computedWelcome), 1),
      (_ctx.message)
        ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(_ctx.message), 1))
        : _createCommentVNode("", true),
      (_ctx.errorMessage)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _hoisted_5,
            _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.errorMessage), 1)
          ]))
        : _createCommentVNode("", true),
      (_ctx.googleUrl || _ctx.azureUrl)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            (_ctx.googleUrl)
              ? (_openBlock(), _createBlock(_component_ui_button, {
                  key: 0,
                  class: "drivr-auth-ui__button",
                  label: "Google",
                  variant: "neutral",
                  size: "large",
                  icon: "google",
                  loading: _ctx.loading === 'google',
                  disabled: _ctx.loading,
                  block: "",
                  onClick: _ctx.initializeGoogleAuth
                }, null, 8, ["loading", "disabled", "onClick"]))
              : _createCommentVNode("", true),
            (_ctx.azureUrl)
              ? (_openBlock(), _createBlock(_component_ui_button, {
                  key: 1,
                  class: "drivr-auth-ui__button",
                  label: "Microsoft",
                  variant: "neutral",
                  size: "large",
                  icon: "azure",
                  block: true,
                  loading: _ctx.loading === 'azure',
                  disabled: _ctx.loading,
                  onClick: _ctx.initializeAzureAuth
                }, null, 8, ["loading", "disabled", "onClick"]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      (_ctx.formUrl)
        ? (_openBlock(), _createElementBlock("form", {
            key: 3,
            action: _ctx.formUrl,
            method: "POST",
            class: "drivr-auth-ui__form",
            onSubmit: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onSubmit && _ctx.onSubmit(...args)))
          }, [
            (_ctx.googleUrl || _ctx.azureUrl)
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, _hoisted_11))
              : _createCommentVNode("", true),
            _createVNode(_component_ui_input, {
              id: "username",
              modelValue: _ctx.username,
              "onUpdate:modelValue": [
                _cache[0] || (_cache[0] = ($event: any) => ((_ctx.username) = $event)),
                _ctx.updateUsername
              ],
              autocomplete: "username",
              class: "drivr-auth-ui__input",
              required: "",
              name: "username",
              type: "text",
              label: "Username",
              disabled: _ctx.loading,
              autofocus: !_ctx.username
            }, null, 8, ["modelValue", "disabled", "autofocus", "onUpdate:modelValue"]),
            _createVNode(_component_ui_input, {
              id: "password",
              modelValue: _ctx.password,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.password) = $event)),
              class: "drivr-auth-ui__input",
              required: "",
              name: "password",
              type: "password",
              label: "Password",
              disabled: _ctx.loading,
              autofocus: _ctx.username,
              autocomplete: "current-password"
            }, null, 8, ["modelValue", "disabled", "autofocus"]),
            _createVNode(_component_ui_button, {
              class: "drivr-auth-ui__button",
              variant: "primary",
              block: "",
              size: "default",
              label: "Login",
              loading: _ctx.loading === 'form',
              disabled: _ctx.loading,
              type: "submit"
            }, null, 8, ["loading", "disabled"]),
            (_ctx.forgetCallback)
              ? (_openBlock(), _createBlock(_component_ui_button, {
                  key: 1,
                  class: "drivr-auth-ui__button",
                  label: "Forgot Password?",
                  variant: "text",
                  size: "default",
                  disabled: _ctx.loading,
                  block: "",
                  onClick: _ctx.initializeForgotPassword
                }, null, 8, ["disabled", "onClick"]))
              : _createCommentVNode("", true)
          ], 40, _hoisted_8))
        : _createCommentVNode("", true)
    ])
  ], 2))
}